import React from "react"
import a23logo from '../assets/a23_avatar_logo.png'
import { connect } from "react-redux";
import { toggleModalAction } from '../redux/actions/userAction'

class VerificationAlert extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            Loading: false,
            btntxt: "Verify",
          };  
    }
 render(){
     return(
         <div>
               <div class="relative absolute--fill flex justify-center items-center center left-1 right-1 white w7 ">
               <img class="absolute black nt4  left-0 top-0 right-0 h3 w3 center white flex justify-center items-center  pointer z-9999 " src={a23logo} alt="not available" ></img>
               <div className="center br2 ba pa1 b--black-10 flex flex-column br1" style={{backgroundColor:"#fffdea",color:"#032146",bordercolor:"#EABF6979",paddingTop: "1rem" }}   
               >          
                <div className="db pt2 f6 mt3 center">
                
                
                <div className="w-100 db f6 tc">
                    <h4 className=" mt0 mb2 fw6 pa1" style={{color:"#032146"}}>{this.props.header}</h4>
                    <p className=" f6 ml1 mr1 " style={{color:"#032146"}}>{this.props.body}</p>
                </div>
                <div className="center tc">
                <button type="submit" className=" tc center pointer bw0 ba br2 w-40 dib pv2  ph4 btn-green btn-green-login white" onClick={()=>this.props.toggleModalAction(false)}>{this.props.btntext}
                
                    </button>
                    <div className="h1"></div>
                </div>
         </div>
         </div>
         </div>
         </div>
        
     )
 }
}
const mapStateToProps = state => ({
    modalState: state.userState
  });
  
  export default connect(
    mapStateToProps,
    { toggleModalAction }
  )(VerificationAlert);